import { HttpRequest } from '@angular/common/http';
import { IAuthService, RequestConfigProperties } from 'interfaces-lib';
import { Observable, of } from 'rxjs';

export class NoAuthService implements IAuthService {
  getToken(): Observable<string | undefined> {
    return of(undefined);
  }

  getRequestProperties(req: HttpRequest<any>, token: string): RequestConfigProperties | undefined {
    return undefined;
  }

  finishAuthFlow(responseUrl: string): string {
    return window.location.origin;
  }

  getTenantId(jwt: string): string {
    return '';
  }
}
